import React from "react";
import DataGrid, {
  Column,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Selection,
  Scrolling,
  ColumnFixing,
} from "devextreme-react/data-grid";
import Box from "@mui/material/Box";
import { api_path } from "../../shared.js";
import { createStore } from "devextreme-aspnet-data-nojquery";
export default function RecentActivityComponent({ userId }) {
  const url = `${api_path}/customer/customer_activities.php?CRM_UID=${userId}&CRM_CUSCODE=0&get10=1`;

  const dataSource = createStore({
    key: "SALES_ACTIVITY_ID",
    loadUrl: `${url}`,
  });
  const cellPrepared = (e) => {
    if (e.rowType === "data") {
      const cusCode = e.data.CRM_CUSCODE; // เอา id จาก field crm_cuscode
      if (e.column.dataField === "ACTIVITY_NAME") {
        e.cellElement.innerHTML =
          "<span class='status-button badge activity-" +
          e.data.ACTIVITY_NAME.toLowerCase().replace(/\s/g, "-") +
          "'><a href='Customer?customer_id=" +
          cusCode +
          "'  title='View' target='_blank' style='color: #FFFFFF;'>" +
          e.data.ACTIVITY_NAME +
          "</a></span>";
      }
      if (e.column.dataField === "CUSTOMER_NAME") {
        e.cellElement.innerHTML =
          "<span class='link2'><a href='Customer?customer_id=" +
          cusCode +
          "'  title='View' target='_blank''>" +
          e.data.CUSTOMER_NAME +
          "</a></span>";
      }
      if (e.column.dataField === "TOPIC") {
        e.cellElement.innerHTML =
          "<span class='link2'><a href='Customer?customer_id=" +
          cusCode +
          "'  title='View' target='_blank''>" +
          e.data.TOPIC +
          "</a></span>";
      }
    }
  };
  return (
    <div className="p-4 bg-white shadow rounded-2xl">
      <h5 className="font-semibold mb-2">🕒 Recent Activity</h5>
      <Box sx={{ maxHeight: 500, overflow: "auto" }}>
        <DataGrid
          onCellPrepared={cellPrepared}
          dataSource={dataSource}
          showBorders={true}
          columnAutoWidth={true}
          rowAlternationEnabled={true}
          showScrollbar={true}
          keyExpr="CRM_CUSCODE"
          height={500}
        >
          <Scrolling
            rowRenderingMode="virtual"
            showScrollbar="always"
            useNative="false"
            scrollByThumb="true"
          ></Scrolling>
          <ColumnFixing enabled={true} />
          <FilterRow visible={true} />
          <FilterPanel visible={false} />
          <HeaderFilter visible={true} />
          <Selection mode="single" />
          <Column
            dataField="CRM_CUSCODE"
            caption="CRM_CUSCODE"
            visible={false}
          />
          <Column dataField="TOPIC" caption="Topic" />
          <Column
            dataField="CUSTOMER_NAME"
            caption="Customer"
            allowHiding={false}
          />
          <Column
            dataField="ACTIVITY_NAME"
            caption="Activity"
            allowHiding={false}
          />
          <Column dataField="CREATE_BY" caption="BY" />
          <Column
            dataField="ACTIVITY_DATE"
            caption="Date"
            dataType="date" // ให้เป็น date (หรือ 'datetime' ถ้าต้องการเวลา)
            format="dd-MMM-yyyy HH:mm"
            groupInterval="day" // สำคัญ: บอกให้ HeaderFilter รู้ว่าจะจัดกลุ่มเป็นวัน
          >
            <HeaderFilter allowSearch={true} />
          </Column>
        </DataGrid>
      </Box>
    </div>
  );
}
